import React, { memo, useCallback } from 'react';
import Player from '../Player';
import styles from './SongPage.module.scss';

const PlayerSection = memo(
  ({ songDetails, handleSongEnd, playerRef, sectionRef, onPlayStateChange }) => {
    const handleVideoEnd = useCallback(() => {
      if (handleSongEnd) {
        handleSongEnd();
      }
    }, [handleSongEnd]);

    return (
      <div ref={sectionRef} className={styles.header}>
        {songDetails.URL && (
          <Player
            ref={playerRef}
            Url={songDetails.URL}
            onEnded={handleVideoEnd}
            onPlayStateChange={onPlayStateChange}
          />
        )}
      </div>
    );
  }
);

PlayerSection.displayName = 'PlayerSection';

export default PlayerSection;
